import { MDBBadge, MDBBtn, MDBChip, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle } from 'mdb-react-ui-kit';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddRemoveNumbers, formattedNumber, unFormatNumber } from '../views/popups/phonenumbers/AddRemoveNumbers';
import DeleteNumbers from '../views/popups/phonenumbers/DeleteNumbers';
import PopupLoader from '../views/popups/PopupLoader';
import PopupLoaderNew from '../views/popups/PopupLoaderNew';
import { getImpExpStatusNew } from '../apiclients/CommonUtils';
import ImportProgressWarning from '../apiclients/ImportProgressWarning';
import ImpExpRedirectPopup from '../apiclients/ImpExpRedirectPopup';
import ImportUser from './editviews/user/ImportUser';

function TelephoneNumbers(props) {
    const { t, i18n } = useTranslation();
    const [AddNumbers, setAddNumbers] = useState(false);
    const toggleNumbers = () => setAddNumbers(!AddNumbers);
    const [isdeleteNumber, setIsDeleteNumbers] = useState(false);
    const dtogglePopup = () => setIsDeleteNumbers(!isdeleteNumber);
    const [showExportWarning, setShowExportWarning] = useState(false);
    const exportwarningToggle = () => setShowExportWarning(!showExportWarning);
    const [warningMessage, setWarningMessage] = useState("");
    const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
    const [importUser, setimportUser] = useState(false);
    const importuserToggle = () => setimportUser(!importUser);
    const [firstRequest, setfirstRequest] = useState(false);

    const handleDeleteClose = () => {
        props.setSavedPhoneNumbers(props?.dbPhoneNumbers ?? props.savedPhoneNumbers);
        dtogglePopup();

    }

     const handleDelete = async (number) => {
        if (props.faxerrorkey) {
            props.clearErrors(props.faxerrorkey);
        }

        const unformatNum = unFormatNumber(number);

        const updateAddPHNum = props.savedPhoneNumbers.filter(
            (num) => unformatNum !== num
        );
        props.setSavedPhoneNumbers(updateAddPHNum);
        const result = await getImpExpStatusNew();
        if (result.status !== 0) {
            if (result.isOwnUser) {
                setShowImpExpRedirect(true);
                props.setSavedPhoneNumbers(props?.dbPhoneNumbers ?? props.savedPhoneNumbers);
            } else {
                const { userInfo } = result;
                if (userInfo?.isaccount) {
                    setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
                } else {
                    setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
                }
                exportwarningToggle();
                props.setSavedPhoneNumbers(props?.dbPhoneNumbers ?? props.savedPhoneNumbers);
            }
            return;
        }
        dtogglePopup();
        props.setUpdatePHNum([unformatNum]);
    };

    const addNumberRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    function handleClick() {
        addNumberRef.current.click();
    }

    const checkSMSEnable = (phnumber, smsPhnumbers) => {
        const match = smsPhnumbers.filter((item) => item.phnumber === phnumber);
        //console.log("res:::::"+ (match[0].issmsphnumber==1) + " phnumber"+ phnumber +"match" + JSON.stringify(match[0]))
        return (match[0]?.issmsphnumber == 1)
    };

    const handleImportAndProceed = async () => {
        const result = await getImpExpStatusNew();
        if (result.status === 0) {
            toggleNumbers();
        } else if (result.isOwnUser) {
            setShowImpExpRedirect(true);
        } else {
            const { userInfo } = result;
            if (userInfo?.isaccount) {
                setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
            } else {
                setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
            }
            exportwarningToggle();
        }
    }


    return (
        <>
            <MDBBtn hidden={true} onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }} />
            <div className="add-numbermain">
                <div className="tel-numbers fw-500">{props.smsGroupFlag ? t("DID") : t("telephone_Numbers")}</div>
                {!props.isstreamsReq && (
                    <MDBBtn
                        className="ms-2"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent the form submission
                            if (props.faxerrorkey) {
                                props.clearErrors(props.faxerrorkey);
                            }
                             handleImportAndProceed();
                        }}
                    >
                        <MDBIcon fas icon="plus" size="sm" /> {t("add_Numbers")}
                    </MDBBtn>
                )}
            </div>


            <div className="mt-2" style={{ paddingLeft: "7px", paddingRight: "7px" }}>

                <div className="chips chips-placeholder">
                    {props.savedPhoneNumbers &&
                        props.savedPhoneNumbers.length > 0 &&
                        props.savedPhoneNumbers.map((phone) => (
                            <>
                                <span
                                    {...(props.isstreamsReq
                                        ? {
                                            title:
                                                "User does not have permission to edit",
                                            className: "disabled-form cursor-notAllowed",
                                            onClick: (e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            },
                                        }
                                        : {})}
                                >

                                    <MDBChip
                                        className="m-chip d-inline py-2 px-3"
                                        label="Example label"

                                        {...(!props.isstreamsReq
                                            ? {
                                                onDelete: () => handleDelete(phone),
                                                closeIcon: true,
                                            }
                                            : {})}
                                        key={phone}
                                        size="sm"
                                    >
                                        {formattedNumber(phone)}
                                        {/* {props.smsPhNumberDtls?.current?.length > 0 && checkSMSEnable(phone, props.smsPhNumberDtls.current) && <MDBBadge color="primary" title="SMS Capable" className="fw-400">
                                            <MDBIcon far icon="comment-alt" />
                                            </MDBBadge>} */}
                                    </MDBChip>
                                </span>

                            </>
                        ))}
                </div>

            </div>


            {AddNumbers && (
                <PopupLoaderNew
                    // size="lg"
                    // className="modal-lg"
                    title={"Add Numbers"}
                    content={
                        <AddRemoveNumbers
                            selectedNum={props.savedPhoneNumbers}
                            setUpdatePHNum={props.setUpdatePHNum}
                            setUpdateNumbersExecuted={props.setUpdateNumbersExecuted}
                            onClose={toggleNumbers}
                            sourceNumber={props.sourceNumber}
                            ref={addNumberRef}
                            setIsloading={setisLoading}
                            smsPhNumberDtls={props.smsPhNumberDtls}
                            checkSMSEnable={checkSMSEnable}
                        />
                    }
                    onShow={setAddNumbers}
                    onClose={toggleNumbers}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={1}
                />
            )}

            {isdeleteNumber && (
                <PopupLoaderNew
                    title={"Remove Number"}
                    content={
                        <DeleteNumbers
                            onClose={handleDeleteClose}
                            setDeleteNumberFlag={props.setDeleteNumberFlag}
                            ref={addNumberRef}
                            setIsloading={setisLoading}
                        />
                    }
                    onShow={setIsDeleteNumbers}
                    onClose={handleDeleteClose}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}
            {showExportWarning && (
                <ImportProgressWarning
                    warningToggle={exportwarningToggle}
                    setShowWarning={setShowExportWarning}
                    onOk={exportwarningToggle}
                    message={warningMessage}
                />
            )}

            {showImpExpRedirect && (
                <ImpExpRedirectPopup
                    onProceed={() => {
                        setShowImpExpRedirect(false);
                        setfirstRequest(true);
                        importuserToggle();
                    }}
                    onCancel={() => setShowImpExpRedirect(false)}
                />
            )}

            <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
                <MDBModalDialog size="fullscreen">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Import User Template</MDBModalTitle>
                        </MDBModalHeader>
                        <MDBModalBody className="pb-0">
                            <ImportUser
                                onClose={importuserToggle}
                                setIsloading={() => {}}
                                onShow={setimportUser}
                                show={importUser}
                                firstRequest={firstRequest}
                                setfirstRequest={setfirstRequest}
                            />
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    )
}

export default TelephoneNumbers
